<script lang="ts" setup>
    import { computed } from 'vue'
    import UserCreateDialog from '@/js/components/Benutzer/UserCreateDialog.vue'
    import { useUserStore } from '@/js/stores/user'

    const props = defineProps({
        modulVerantwortliche: {
            type: Array,
            required: true
        },
        allowEdit: {
            type: Boolean,
            required: false,
            default: true
        },
        tooltip: {
            type: String,
            required: false,
            default: () => ''
        },
        language: {
            type: String,
            required: false,
            default: () => 'deutsch'
        }
    })

    const title = computed(() =>
        props.language === 'englisch'
            ? 'Person responsible for the module | Modulverantwortliche'
            : 'Modulverantwortliche'
    )

    const userStore = useUserStore()
    const emit = defineEmits(['modulVerantwortlicherSaved'])

    const userIdLabelMap = computed(() => {
        if (!props.modulVerantwortliche) return []
        const userIds = props.modulVerantwortliche ? props.modulVerantwortliche : []
        return userIds.map((userId) => {
            const user = userStore.getUserById(userId)

            return {
                id: userId,
                label: `${user?.titel} ${user?.vorname} ${user?.nachname}`
            }
        })
    })

    const saveModulVerantwortlicher = (modulverantwortliche) => {
        emit('modulVerantwortlicherSaved', modulverantwortliche)
    }
    const autoCompleteUsers = computed(() => {
        return userStore.getUsersForAutocompletion
    })
</script>

<template>
    <common-multi-edit
        :title="title"
        edit-key="modulverantwortliche"
        :entries="userIdLabelMap"
        :handle-ids="true"
        :allow-edit="allowEdit"
        :auto-complete-data="autoCompleteUsers"
        :tool-tip="tooltip"
        @text-saved="saveModulVerantwortlicher"
    >
        <template #create-user-dialog>
            <user-create-dialog :with-role="false">
                <template #activator="{ props }">
                    <v-btn
                        v-bind="props"
                        border
                        height="inherit"
                        class="border-primary border-opacity-100 text-grey"
                        color="primary-lighten-2"
                        tile
                        variant="flat"
                        icon="mdi-plus"
                    />
                </template>
            </user-create-dialog>
        </template>
    </common-multi-edit>
</template>

<script></script>

<style scoped></style>
